var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 0.726532C15.3783 0.726532 19.6722 5.41003 19.8508 5.60917C20.0499 5.83175 20.0499 6.16823 19.8508 6.39081C19.6722 6.58995 15.3782 11.2734 10.0001 11.2734C4.62191 11.2734 0.327911 6.58995 0.149356 6.39081C-0.0497853 6.16823 -0.0497853 5.83175 0.149356 5.60917C0.327911 5.41003 4.62183 0.726532 10.0001 0.726532ZM5.89848 5.99999C5.89848 8.26137 7.73868 10.1016 10.0001 10.1016C12.2614 10.1016 14.1016 8.26137 14.1016 5.99999C14.1016 3.73861 12.2614 1.89841 10.0001 1.89841C7.73868 1.89841 5.89848 3.73861 5.89848 5.99999ZM11.3237 3.40115C10.8785 3.7201 10.5859 4.23865 10.5859 4.82811C10.5859 5.98132 11.6998 6.8737 12.8797 6.49382C12.6432 7.87367 11.4462 8.92969 9.99994 8.92969C8.38459 8.92969 7.07024 7.61535 7.07024 5.99999C7.07024 4.38463 8.38459 3.07029 9.99994 3.07029C10.4787 3.07029 10.9242 3.19666 11.3237 3.40115Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.23f22c4a0b8dbffb2f47d11ac0a94a74.svg";
export { ForwardRef as ReactComponent };